import {
  Globe01Icon,
  Loading01Icon,
  Lock01Icon,
} from '@langchain/untitled-ui-icons';

import { IconButton } from '@/design-system';
import { usePublicSharingDisabled } from '@/hooks/usePublicSharingDisabled';

export default function MakePublicButton({
  isPublic,
  disabled,
  isMutating,
  updatePublic,
}) {
  const publicSharingDisabled = usePublicSharingDisabled();
  const tooltipTitle = publicSharingDisabled
    ? 'Public sharing disabled, contact your organization administrator'
    : isPublic
    ? 'Make Private'
    : 'Make Public';

  // Determine the icon for the design-system version
  const getIcon = () => {
    if (isMutating) return Loading01Icon;
    return isPublic ? Globe01Icon : Lock01Icon;
  };

  return (
    <IconButton
      size="md"
      variant="outlined"
      color="secondary"
      onClick={() => updatePublic(!isPublic)}
      disabled={disabled || isMutating || publicSharingDisabled}
      icon={getIcon()}
      label={tooltipTitle}
      iconClassName={isMutating ? 'animate-spin' : ''}
    />
  );
}
